<header class="product-summary-wrapper">
  <bau365-breadcrumb [breadcrumbElements]="breadcrumbElements"></bau365-breadcrumb>
  <div class="mdc-layout-grid actions">
    <div class="mdc-layout-grid__inner">
      <div
        class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone topnavi">
        <div class="topnavi__actions">
          <button mat-icon-button class="actions__link" (click)="trackShareButtonDialogOpened($event)">
            <mat-icon class="actions__icon">share</mat-icon>
          </button>
          <bau365-toggle-watchlist-item
            entityType="PRODUCT"
            [entityId]="product?.id"
            [pageContext]="'product-details'"
            [fairId]="fairId"></bau365-toggle-watchlist-item>
        </div>
      </div>
    </div>
  </div>
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <div class="product-summary-wrapper-inner">
          @if (product?.images?.length ?? 0 > 0) {
          <div class="product-image-gallery-container">
            <planone-swiper [desktopVariant]="'preview'" (interaction)="trackSwiperInteraction($event)">
              @for (image of product?.images; track identifyImage($index, image)) {
              <ng-template #slide>
                <img
                  [src]="image.resource | ImageUrl : image.provider"
                  width="100%"
                  height="auto"
                  [alt]="image?.description" />
              </ng-template>
              } @for (image of product?.images; track identifyImage($index, image)) {
              <ng-template #title>
                @if (image?.description) {
                {{ image?.description }}
                } @if (!image?.description) {
                <i i18n="@@featureProductDetails-galleryImageDescriptionFallback">Keine Beschreibung</i>
                }
              </ng-template>
              }
            </planone-swiper>
          </div>
          }
          <div class="product-summary-container">
            <h1 class="mat-headline-1 product__headline">{{ product?.name }}</h1>
            @if (featureProductAtBooth) {
            <mat-chip-listbox>
              @if (product?.product_at_booth) {
              <mat-chip-option selectable="false" class="product__chip nonselectable">
                <mat-icon class="product__infoicon">info</mat-icon>
                <span i18n="@@featureProductDetails-exhibited">Produkt auf der Messe</span>
              </mat-chip-option>
              } @else {
              <mat-chip-option selectable="false" class="product__chip nonselectable">
                <mat-icon class="product__infoicon">error</mat-icon>
                <span i18n="@@featureProductDetails-notexhibited">Produkt nicht auf der Messe</span>
              </mat-chip-option>
              }
            </mat-chip-listbox>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
